export default __webpack_public_path__ + "static/media/Nerd_Velma.e99fe83e.png";